import { NgModule } from '@angular/core';
import { PasswordRequirementsPipe } from './password-requirements.pipe';

@NgModule({
    declarations: [PasswordRequirementsPipe],
    exports: [PasswordRequirementsPipe],
})
export class PasswordRequirementsPipeModule {}
